export default __webpack_public_path__ + "static/media/01 - Showcase.3f35b359.png";